import React from 'react';

import { withRouter } from 'react-router-dom';

import Drawer from 'material-ui/Drawer';
import { List } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';

import ShareIcon from 'material-ui/svg-icons/social/share';
import PersonIcon from 'material-ui/svg-icons/social/person';
import TrashIcon from 'material-ui/svg-icons/action/delete';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import PeopleIcon from 'material-ui/svg-icons/social/people';
import PaymentIcon from 'material-ui/svg-icons/action/payment';
import TimelineIcon from 'material-ui/svg-icons/action/timeline';
import ComingSoonBadge from './ComingSoonBadge';
import AppDrawerItem from './AppDrawerItem';
import './AppDrawer.css';


class MasonryFeed extends React.Component {

  constructor() {
    super();
    this.state ={
      drawerOpen: false,
    }
  }

  render() {
    const { open, feed, history } = this.props;
    const selectedStyle = {
      color: 'rgb(255, 64, 129)',
      fontWeight: 600,
    }
    return (
      <Drawer
        docked={false}
        open={open}
        onRequestChange={this.props.onRequestChange}
        style={{
          textAlign: 'left',
        }}
        className="drawer"
        width={300}
      >
        <AppDrawerItem />
        <List>
          <Subheader className="subheader">Feeds</Subheader>
          <AppDrawerItem
            className="list-item"
            style={feed === 'latest' ? selectedStyle : {}}
            primaryText="Latest first"
            leftIcon={<TimelineIcon />}
            onTouchTap={(e) => {
              const { selectFeed } = this.props;
              if (selectFeed) {
                selectFeed('latest');
              }
            }}
          />
          <AppDrawerItem
            className="list-item"
            style={feed === 'shared' ? selectedStyle : {}}
            primaryText="Shared"
            leftIcon={<ShareIcon />}
            onTouchTap={(e) => {
              const { selectFeed } = this.props;
              if (selectFeed) {
                selectFeed('shared');
              }
            }}
            badge={<ComingSoonBadge />}
            disabled
          />
          <AppDrawerItem
            className="list-item"
            style={feed === 'trash' ? selectedStyle : {}}
            primaryText="Trash"
            leftIcon={<TrashIcon />}
            onTouchTap={(e) => {
              const { selectFeed } = this.props;
              if (selectFeed) {
                selectFeed('trash');
              }
            }}
          />
        </List>
        <Divider />
        <List>
          <Subheader className="subheader">User Profile</Subheader>
          <AppDrawerItem
            className="list-item"
            primaryText="Buddies"
            leftIcon={<PeopleIcon />}
            badge={<ComingSoonBadge />}
            disabled
          />
          <AppDrawerItem
            className="list-item"
            primaryText="Subscription"
            leftIcon={<PaymentIcon />}
            badge={<ComingSoonBadge />}
            disabled
          />
        </List>
        <Divider />
        <List>
          <Subheader className="subheader">Settings</Subheader>
          <AppDrawerItem
            className="list-item"
            primaryText="User Settings"
            leftIcon={<PersonIcon />}
            onTouchTap={e => {
              history.push('/profile');
            }}
          />
          <AppDrawerItem
            className="list-item"
            primaryText="General Settings"
            leftIcon={<SettingsIcon />}
            badge={<ComingSoonBadge />}
            disabled
          />
        </List>
      </Drawer>
    );
  }
}

export default withRouter(MasonryFeed);



// WEBPACK FOOTER //
// ./src/components/AppDrawer.jsx